export const backUri = "https://api.account.codinsight.app/api/v1"
